'use strict';
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dAdmin$002dUser from "./app.data.-App-Auth-Data$-Admin-User.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dGeneral$002dPractice$002dUser from "./app.data.-App-Auth-Data$-General-Practice-User.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dPharmacy$002dUser from "./app.data.-App-Auth-Data$-Pharmacy-User.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $f_Lapp_data_AppAuthData$Base__toAdmin__Lapp_data_AppAuthData$AdminUser($thiz) {
  if ($j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dGeneral$002dPractice$002dUser.$is_Lapp_data_AppAuthData$GeneralPracticeUser($thiz)) {
    return new $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dAdmin$002dUser.$c_Lapp_data_AppAuthData$AdminUser($thiz);
  }
  if ($j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dPharmacy$002dUser.$is_Lapp_data_AppAuthData$PharmacyUser($thiz)) {
    return new $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dAdmin$002dUser.$c_Lapp_data_AppAuthData$AdminUser($thiz);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError($thiz);
}
export { $f_Lapp_data_AppAuthData$Base__toAdmin__Lapp_data_AppAuthData$AdminUser as $f_Lapp_data_AppAuthData$Base__toAdmin__Lapp_data_AppAuthData$AdminUser };
function $is_Lapp_data_AppAuthData$Base(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_data_AppAuthData$Base)));
}
export { $is_Lapp_data_AppAuthData$Base as $is_Lapp_data_AppAuthData$Base };
function $isArrayOf_Lapp_data_AppAuthData$Base(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$Base)));
}
export { $isArrayOf_Lapp_data_AppAuthData$Base as $isArrayOf_Lapp_data_AppAuthData$Base };
//# sourceMappingURL=app.data.-App-Auth-Data$-Base.js.map
